// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1IZCG","form":"styles_form__1uZlz"};